import { render, staticRenderFns } from "./KitchenSinkPlantFormList.vue?vue&type=template&id=1b08465d&"
import script from "./KitchenSinkPlantFormList.vue?vue&type=script&lang=ts&"
export * from "./KitchenSinkPlantFormList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports